import './Result.svelte.css';
/* src/Result.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	space
} from "./_snowpack/pkg/svelte/internal.js";

import { createEventDispatcher } from './_snowpack/pkg/svelte.js';

function create_fragment(ctx) {
	let div4;
	let div0;
	let t1;
	let div1;
	let t3;
	let textarea0;
	let t4;
	let div2;
	let t6;
	let textarea1;
	let textarea1_value_value;
	let t7;
	let div3;
	let mounted;
	let dispose;

	return {
		c() {
			div4 = element("div");
			div0 = element("div");
			div0.textContent = "x";
			t1 = space();
			div1 = element("div");
			div1.textContent = "Seed Phrase";
			t3 = space();
			textarea0 = element("textarea");
			t4 = space();
			div2 = element("div");
			div2.textContent = "Hex Value";
			t6 = space();
			textarea1 = element("textarea");
			t7 = space();
			div3 = element("div");
			div3.textContent = "Okay";
			attr(div0, "class", "close-result svelte-uh3rtk");
			attr(div1, "class", "seed-lbl svelte-uh3rtk");
			attr(textarea0, "class", "seed svelte-uh3rtk");
			textarea0.value = /*seed*/ ctx[1];
			attr(div2, "class", "hex-lbl svelte-uh3rtk");
			attr(textarea1, "class", "hex svelte-uh3rtk");
			textarea1.value = textarea1_value_value = /*result*/ ctx[0].hex;
			attr(div3, "class", "okay svelte-uh3rtk");
			attr(div4, "class", "result svelte-uh3rtk");
		},
		m(target, anchor) {
			insert(target, div4, anchor);
			append(div4, div0);
			append(div4, t1);
			append(div4, div1);
			append(div4, t3);
			append(div4, textarea0);
			append(div4, t4);
			append(div4, div2);
			append(div4, t6);
			append(div4, textarea1);
			append(div4, t7);
			append(div4, div3);

			if (!mounted) {
				dispose = [
					listen(div0, "click", /*close*/ ctx[2]),
					listen(div3, "click", /*close*/ ctx[2])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*seed*/ 2) {
				textarea0.value = /*seed*/ ctx[1];
			}

			if (dirty & /*result*/ 1 && textarea1_value_value !== (textarea1_value_value = /*result*/ ctx[0].hex)) {
				textarea1.value = textarea1_value_value;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div4);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let seed;
	const dispatch = createEventDispatcher();
	let { result = { seed: [], hex: '' } } = $$props;

	function close() {
		dispatch('close');
	}

	$$self.$$set = $$props => {
		if ('result' in $$props) $$invalidate(0, result = $$props.result);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*result*/ 1) {
			$: $$invalidate(1, seed = result.seed.join(' '));
		}
	};

	return [result, seed, close];
}

class Result extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { result: 0 });
	}
}

export default Result;